<template>
  <div class="classroom">
    <div class="classroom_navbar">
      <div
        class="classroom_navbar_item"
        :class="{ isActive: isActive === 0 }"
        @click="handleToJoinClass"
      >
        <img class="icon" :src="icons.joinclass" alt="加入课堂" />
        <div class="icon_text">加 入 课 堂</div>
      </div>

      <div
        class="classroom_navbar_item"
        :class="{ isActive: isActive === 1 }"
        @click="handleToStartClass"
      >
        <img class="icon" :src="icons.startclass" alt="开始上课" />
        <div class="icon_text">开 始 上 课</div>
      </div>

      <div
        class="classroom_navbar_item"
        :class="{ isActive: isActive === 2 }"
        @click="handleToInfo"
      >
        <img class="icon" :src="icons.info" alt="申请通知" />
        <div class="icon_text">申 请 通 知</div>
      </div>
    </div>
    <div class="classroom_main">
      <router-view :key="$route.name" />
    </div>
  </div>
</template>

<script>
import joinclass from '@/assets/joinclass.png'
import startclass from '@/assets/startclass.png'
import info from '@/assets/info.png'
const icons = { joinclass, startclass, info }
export default {
  name: 'ClassRoom',
  mounted() {
    this.isActive = parseInt(sessionStorage.getItem('isActive2')) || 0
  },
  data() {
    return {
      icons,
      isActive: 0
    }
  },
  methods: {
    handleToJoinClass() {
      this.isActive = 0;
      sessionStorage.setItem('isActive2', 0)
      this.$router.push({ path: '/classroom/joinclass' });
    },
    handleToStartClass() {
      this.isActive = 1;
      sessionStorage.setItem('isActive2', 1)
      this.$router.push({ path: '/classroom/startclass' });
    },
    handleToInfo() {
      this.isActive = 2;
      sessionStorage.setItem('isActive2', 2)
      this.$router.push({ path: '/classroom/info' });
    }
  }
}
</script>

<style scoped lang=scss>
.classroom {
  display: flex;
  width: 100%;
  height: 100%;
}
.classroom_navbar {
  width: 310px;
  height: 100%;
  border-right: 2px solid #ededed;
  padding-top: 52px;
  background-color: #fafbfd;
  flex-shrink: 0;
  flex-grow: 0;

  .classroom_navbar_item {
    display: flex;

    justify-content: center;
    align-items: center;
    width: 100%;
    height: 62px;
    cursor: pointer;
    .icon {
      width: 42px;
      height: 42px;
      margin-right: 16px;
      margin-left: -80px;
    }
    .icon_text {
      color: #5d5e69;
      font-weight: 400;
      font-size: 16px;
    }
  }
}
.isActive {
  background-color: #eceff5;
}
.classroom_main {
  width: 100%;
  height: 100%;
}
</style>